/**
 * Adapter barrel.
 *
 * Importing this module pulls in every battle-type adapter and triggers their
 * `registerAdapter(...)` side-effects. Anything that calls `getAdapter(...)`
 * should ensure this barrel has been imported at least once before lookup.
 *
 * Convention: high-level entry points (the BattleScreen + the lobby route)
 * import this barrel; lower-level utilities never need to.
 */

import './SquareTrainerAdapter';
import './PositionTrainerAdapter';
import './PuzzleDashAdapter';
import './PuzzleRoyaleAdapter';

export {default as squareTrainerAdapter} from './SquareTrainerAdapter';
export {default as positionTrainerAdapter} from './PositionTrainerAdapter';
export {default as puzzleDashAdapter} from './PuzzleDashAdapter';
export {default as puzzleRoyaleAdapter} from './PuzzleRoyaleAdapter';
